export default __webpack_public_path__ + "static/family_health_tree-75d685aa56595e8549a1c00b8709df20.pdf";